<div (mouseover)="onArrowHover($event, true)" (mouseout)="onArrowHover($event, false)" (touchend)="onArrowHover($event, false)">
    <div
        class="slides"
        [ngClass]="{ one: mode === SlideshowMode.OneSlide, three: mode === SlideshowMode.ThreeSlides }"
        (swipeleft)="swipeLeft()"
        (swiperight)="swipeRight()">
        <ng-content></ng-content>
        @if (showProgressBar && slides && slides.length > 1) {
            <ms-timer-progress-bar
                [totalDuration]="delay"
                [pauseProgressBar]="pauseProgressBarOnHover"
                [smoothProgressTransition]="true"
                (complete)="swipeLeft()"></ms-timer-progress-bar>
        }
    </div>

    @if (showIndicators) {
        <ms-slideshow-indicators
            [items]="slides"
            [realtotalslidecount]="realtotalslidecount"
            [currentSlideIndex]="currentSlideIndex"
            [indicatorArrow]="indicatorArrow"
            (select)="slideTo($event)"></ms-slideshow-indicators>
    }

    @if (mode === SlideshowMode.ThreeSlides && navigationMode === NavigationMode.Swipe) {
        <div
            class="slide-overlay overlay-left"
            [ngStyle]="{ left: overlayArea?.position, width: overlayArea?.width }"
            (click)="swipeRight()"
            (swipeleft)="swipeLeft()"
            (swiperight)="swipeRight()"></div>
    }
    @if (mode === SlideshowMode.ThreeSlides && navigationMode === NavigationMode.Swipe) {
        <div
            class="slide-overlay overlay-right"
            [ngStyle]="{ right: overlayArea?.position, width: overlayArea?.width }"
            (click)="swipeLeft()"
            (swipeleft)="swipeLeft()"
            (swiperight)="swipeRight()"></div>
    }

    @if (navigationMode === NavigationMode.Arrows && slides && slides.length > 1) {
        <ds-arrow
            class="slide-arrows"
            direction="left"
            variant="strong"
            inverse="false"
            [style.left.px]="arrowPosition"
            [size]="size"
            (click)="arrowClicked('right')" />
    }
    @if (navigationMode === NavigationMode.Arrows && slides && slides.length > 1) {
        <ds-arrow
            class="slide-arrows"
            direction="right"
            variant="strong"
            inverse="false"
            [style.right.px]="arrowPosition"
            [size]="size"
            (click)="arrowClicked('left')" />
    }
</div>
